export default class VideoHelpers {
  static isBlank(input = null) {
    if(input == null) {
      return true;
    } else if(input == undefined) {
      return true;
    } else if(input == "") { // also catch []
      return true;
    } else if(input == "[]") {
      return true;
    } else if(input == "{}") {
      return true;
    } else if(Object.keys(input).length === 0 && input.constructor === Object) {
      return true;
    } else {
      return false;
    }
  }

  static getLang() {
    const allowedLanguage = ['id', 'en']

    try {
      let language = document.documentElement.lang
      if (allowedLanguage.indexOf(language) == -1) { language = 'id' }
      return language
    }
    catch(err) {
      return 'id'
    }
  }
}
